import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { LogoMark } from "../components/site/Logo";
import { TextInput } from "../components/forms/Field";
import { SubmitButton } from "../components/forms/SubmitButton";

export default function AdminLogin({ mode = "admin" }) {
  const { user, login, employeeLogin } = useAuth();
  const nav = useNavigate();
  const isEmp = mode === "employee";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={user.role === "employee" ? "/employee" : "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      if (isEmp) {
        await employeeLogin(email, password);
        nav("/employee");
      } else {
        await login(email, password);
        nav("/admin");
      }
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="grain relative flex min-h-screen items-center justify-center bg-[var(--ink)] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="clip-notch relative w-full max-w-md space-y-8 bg-[var(--ink-2)] p-8 md:p-10" data-testid="admin-login-form">
        <div>
          <LogoMark className="h-11 w-11" />
          <div className="mt-6 grid grid-cols-2 gap-1 rounded-full border border-white/15 p-1 text-sm">
            {[["admin", "Admin", "/admin/login"], ["employee", "Employee", "/employee/login"]].map(([k, l, to]) => (
              <Link key={k} to={to} data-testid={`login-mode-${k}`}
                className={`rounded-full py-2 text-center font-semibold transition-colors ${mode === k ? "bg-[var(--signal)] text-[var(--ink)]" : "text-[var(--bone-2)] hover:text-[var(--bone)]"}`}>{l}</Link>
            ))}
          </div>
          <h1 className="mt-6 font-display text-5xl font-black uppercase leading-none">{isEmp ? "Employee login" : "Admin login"}</h1>
          <p className="mt-2 text-sm text-[var(--bone-2)]">{isEmp ? "Mark attendance and download salary slips" : "Enquiries, applications & employees"}</p>
        </div>
        <TextInput id="admin-email" label={isEmp ? "Employee ID" : "Email"} type={isEmp ? "text" : "email"} placeholder={isEmp ? "e.g. BHI0001" : ""} required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
        <TextInput id="admin-password" label="Password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <SubmitButton loading={loading} testId="admin-login-submit">Sign in</SubmitButton>
      </form>
    </main>
  );
}
